module.exports = __webpack_public_path__ + "Banner_ModuleWrapup_repeatable-2521285a3fd080e365b7dbf0ed5c7292.svg";